import { OfficialModel } from '@clsplus/cls-plus-data-models'
import { types } from 'mobx-state-tree'

const OfficialsSearchMap = types.model('OfficialsSearchMap', {
  type: types.identifier,
  data: types.array(OfficialModel),
})

export default OfficialsSearchMap
